// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"T2-z","dimensionLabel":"U2-z","styleChooserControlWrapper":"V2-z","styleChooserControl":"W2-z","disabled":"X2-z","giftCard":"Y2-z","styleChooserText":"Z2-z"};